import { apiFetch } from '../../lib/api';

export interface PlatformIssue {
  code: string;
  message: string;
}

export interface PlatformValidation {
  validation_state: 'ok' | 'warning' | 'error' | string;
  errors: PlatformIssue[];
  warnings: PlatformIssue[];
}

export interface PlatformSettings {
  schema_version: string;
  source: string;
  environment: string;
  platform: {
    platform_id: string;
    platform_name: string;
    brand_name: string;
    primary_domain: string;
    default_region: string;
    aws_region?: string;
  };
  domains: {
    api: string;
    admin?: string;
    webapp?: string;
    devportal?: string;
    signaling_app: string;
    signaling_device: string;
    public_base_url?: string;
    app_url?: string;
    devportal_url?: string;
  };
  cookies: {
    refresh_cookie_domain: string;
    refresh_cookie_path: string;
    same_site: string;
    secure: boolean;
  };
  families: Array<{
    family_id: string;
    name: string;
    owner_scope: string;
    state: string;
  }>;
  client_apps: Array<{
    client_id: string;
    display_name: string;
    platform: string;
    family_id: string;
    capabilities: string[];
    has_app_key_ref: boolean;
    status: string;
  }>;
  storage: {
    export_bucket_ref?: string;
    developer_docs_bucket_ref?: string;
    recording_bucket_ref?: string;
  };
  secrets: Record<string, string>;
  status: {
    service: string;
    version: string;
    commit?: string;
    build_time?: string;
    config_revision: string;
    deployed_at?: string | null;
    validation_state: 'ok' | 'warning' | 'error' | string;
  };
  validation: PlatformValidation;
}

export function getPlatformSettings(signal?: AbortSignal) {
  return apiFetch<PlatformSettings>('/v3/admin/platform/settings', { signal });
}

